import { render } from "./CadastroEntrevistaSocial.vue?vue&type=template&id=d35a8b1a&scoped=true"
import script from "./CadastroEntrevistaSocial.vue?vue&type=script&lang=js"
export * from "./CadastroEntrevistaSocial.vue?vue&type=script&lang=js"

import "./CadastroEntrevistaSocial.vue?vue&type=style&index=0&id=d35a8b1a&lang=css"
import "./CadastroEntrevistaSocial.vue?vue&type=style&index=1&id=d35a8b1a&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35a8b1a"]])

export default __exports__